.Input {
  appearance: none;
  background-color: var(--rv-bg-app);
  border: 1.5px solid var(--rv-neutral-300);
  border-radius: var(--rv-radius-sm);
  cursor: pointer;
  display: inline-block;
  flex-shrink: 0;
  height: var(--rv-icon-sm);
  position: relative;
  transition:
    background-color var(--rv-dur-fast) var(--rv-ease-out),
    border-color var(--rv-dur-fast) var(--rv-ease-out),
    box-shadow var(--rv-dur-fast) var(--rv-ease-out);
  vertical-align: middle;
  width: var(--rv-icon-sm);
}

.Input:hover:not(:disabled) {
  border-color: var(--rv-fg-2);
}

.Input:focus-visible {
  box-shadow: var(--rv-shadow-ring-focus);
  outline: none;
}

.Input:checked {
  background-color: var(--rv-accent);
  border-color: var(--rv-fg-1);
}

.Input:checked::after {
  border: solid var(--white);
  border-width: 0 2px 2px 0;
  box-sizing: border-box;
  content: '';
  height: var(--rv-text-xxs);
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -55%) rotate(45deg);
  width: var(--rv-radius-md);
}

/* Some but not all (set from script, e.g. a "select all" over a partial pick):
   the checked fill with a dash. */
.Input:indeterminate {
  background-color: var(--rv-accent);
  border-color: var(--rv-fg-1);
}

.Input:indeterminate::after {
  background-color: var(--white);
  content: '';
  height: var(--space-xxs);
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: var(--rv-text-xxs);
}

.Input:disabled {
  cursor: not-allowed;
  opacity: 40%;
}
